import React, { Component } from 'react';
import './../css/master.css';
import './../css/stockLocation.css';
import Header from './header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL = '';
var queryString = require('querystring');
var lstStock = [];
var stockIdCol = 'td:eq(0)';
var stockCol = 'td:eq(1)';

class StockLocation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stock: [],
			flg: true,
			loader: 'none',
			opacity: 1,
		}
	}

	componentDidMount = () => {
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.get(httpURL + '/a/mst/sto/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					stock: response.data.lstStockLocation,
				})
				lstStock = this.state.stock;
				this.setStockTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setStockTable = () => {
		$('#stockTableBody tr').remove();
		var table = document.getElementById('stockTable');
		var tbody = document.getElementById('stockTableBody');
		var filterStock = $('#stock').val().toLowerCase();

		for (var i = 0; i < lstStock.length; i++) {
			var id = lstStock[i].stockLocationId;
			var stock = lstStock[i].stockLocation;

			var row = document.createElement('tr');
			row.id = id;
			row.onclick = (e) => {
				$(e.currentTarget).addClass('selected').siblings().removeClass('selected');
				this.setStockForm(e.currentTarget.id);
				this.setState({ flg: false })
			}

			if (stock.toLowerCase().indexOf(filterStock) === -1)
				continue;

			this.addTD(row, id, 'no-display');
			this.addTD(row, stock, '');

			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	setStockForm = (id) => {
		var stockData = this.getStockData(id);
		if (stockData !== -1) {
			$('#inp_stock').val(stockData.stockLocation);
		}
	}

	getStockData(id) {
		for (var i = 0; i < lstStock.length; i++) {
			if (id == lstStock[i].stockLocationId) {
				return lstStock[i];
			}
		}
		return -1;
	}

	addStockReady = () => {
		$('#stockAddForm').trigger('reset');
		this.setState({ flg: true })
	}

	maintainStock = () => {
		if (this.state.flg) {
			this.addStock();
		} else {
			this.editStock();
		}
	}

	addStock = () => {
		var stockArr = {};
		var stock = $('#inp_stock').val().toUpperCase();
		if (stock == '') {
			toast.warning('Please fill stock location');
			document.getElementById('inp_stock').focus();
			return false;
		}

		stockArr = { 'stockLocationId': 0, 'stockLocation': stock }
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/mst/sto/save',
			queryString.stringify({ 'stockLocation': JSON.stringify(stockArr) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				stockArr.stockLocationId = response.data.stockLocationId;
				lstStock.push(stockArr);
				this.setStockTable();
				this.setStockForm(response.data.stockLocationId);
				this.highlightRow('stockTableBody', response.data.stockLocationId);
				this.setState({ flg: false })
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error("Service failed " + e);
		});
	}

	editStock = () => {
		var stockArr = {};
		var stockLocationId = $('#stockTableBody tr.selected').find(stockIdCol).text();
		var stockLocation = $('#inp_stock').val().toUpperCase();

		if (stockLocationId == '') {
			toast.warning('Please select row');
			return false;
		}

		if (stockLocation == '') {
			toast.warning('Please fill stock location');
			document.getElementById('inp_stock').focus();
			return false;
		}

		stockArr = { 'stockLocationId': stockLocationId, 'stockLocation': stockLocation }
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/mst/sto/save',
			queryString.stringify({ 'stockLocation': JSON.stringify(stockArr) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				var stockIdx = this.getIdxStock(stockLocationId);
				lstStock.splice(stockIdx, 1, stockArr);
				this.setStockForm(stockLocationId);
				this.setStockTable();
				this.highlightRow('stockTableBody', stockLocationId);
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error("Service failed " + e);
		});
	}

	getIdxStock(stockLocationId) {
		for (var i = 0; i < lstStock.length; i++) {
			if (lstStock[i].stockLocationId == stockLocationId) {
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id) {
		$('#' + table + ' tr').each(function () {
			var stockLocationId = $(this).find(stockIdCol).text();
			if (stockLocationId == id) {
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}


	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-7 col-centered">
							<div className="col-sm-4 col-xs-11 padding-remove">
								<table className="tableLayout">
									<thead>
										<tr>
											<th style={{ width: 50, display: 'none' }}>Stock Id</th>
											<th style={{ width: 100 }}>
												<input onChange={this.setStockTable} type="text" className="form-control inp-search" id="stock" placeholder="Stock Location" />
											</th>
										</tr>
									</thead>
								</table>
								<div className="stockTableDiv col-sm-12 col-xs-11 padding-remove">
									<table id="stockTable" className="tableLayout">
										<colgroup>
											<col width="100" />
										</colgroup>
										<tbody id="stockTableBody"></tbody>
									</table>
								</div>
							</div>
							<div className="col-sm-1 col-xs-1">
								<span id="addStock" title="Add stock" onClick={this.addStockReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
							</div>
							<div className="col-sm-7 col-xs-12">
								<form id="stockAddForm" className="form-horizontal">
									<div className="form-group">
										<label className="control-label col-sm-5">Stock Location:<span style={{ color: 'red' }}>*</span></label>
										<div className="col-sm-7">
											<input type="text" className="form-control" placeholder="Stock" id="inp_stock" />
										</div>
									</div>
									<div className="form-group" style={{ marginTop: 50 }}>
										<div className="col-sm-12 text-center">
											<button type="button" onClick={this.maintainStock} className="btn btn-warning">Save</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default StockLocation;
